import { useCallback, useEffect, useState } from "react";
import { ResponseDetailUser, ResponseGetUsers } from "../user.interface";
import userService from "../user.service";

const useGetUser = (customerID: string, enabeld: boolean) => {
  const [data, setData] = useState<ResponseDetailUser>();
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState<unknown>("");

  const callApi = useCallback(() => {
    return userService.getDetailUser(customerID);
  }, [enabeld, customerID]);

  const refetch = useCallback(async () => {
    try {
      setLoading(true);
      const response = await callApi();
      transformResponse(response);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  }, []);

  const transformResponse = useCallback((response: ResponseDetailUser) => {
    if (response) {
      setData(response);
    }
  }, []);

  useEffect(() => {
    if (!enabeld) {
      return;
    }
    (async () => {
      try {
        setLoading(true);
        const response = await callApi();
        transformResponse(response);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    })();
  }, [enabeld, customerID]);

  return { data, error, isLoading, refetch };
};

export default useGetUser;
